export const version = 'v2.2.4-2397-gb113a257a'
